// Module
var code = `<p>{{childType}}</p>
<div class="controls">
  <button
    class="btn material-symbols-outlined"
    data-add-random="false"
    data-child-type="{{childType}}"
    data-event-type="remove"
  >
    remove
  </button>
  <button
    class="btn material-symbols-outlined"
    data-add-random="false"
    data-child-type="{{childType}}"
    data-event-type="add"
  >
    add
  </button>
</div>
<div class="children"></div>
`;
// Exports
module.exports = code;